import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Alert } from 'react-bootstrap';
import { useCookies } from 'react-cookie';
import queryString from 'query-string';
import { useHistory } from 'react-router-dom';
import axiosInterceptor from '../../services/axiosInterceptor';
import '../../styles/home.css';
import twitter_logo from '../../assets/images/twitter.png';
import { FormattedMessage } from 'react-intl';
const DEFAULT_REWARD_VAL=60
const DEFAULT_CURRENCY="$"
function HomePage() {
    const history = useHistory();

    const [authCookie, setAuthCookie, removeAuthCookie] = useCookies([
        'oauth_token',
        'access_token',
        'email_collected'
    ]);
    const [buttonDisable, setButtonDisable] = useState(true);
    const [reward, setReward] = useState(DEFAULT_REWARD_VAL);
    // const [isEnoughCard, setIsEnoughCard] = useState(true);

    // Login Functionality
    const login = () => {
        (async () => {
            try {
                setButtonDisable(true);
                //double check  when user click login
                const responseP = await axiosInterceptor().get(
                    "incas/giftcardPublicPolicy"
                );
                console.log("login() isEnoughGc? "+responseP.data.isEnoughCards)
                if (!responseP.data.isEnoughCards){
                    alert("No GC Left")
                    return
                }

                //OAuth Step 1
                const response = await axiosInterceptor().post(
                    'twitter/auth/request_token'
                );
                if (response?.data?.oauth_token) {
                    //Oauth Step 2
                    setAuthCookie('oauth_token', response?.data?.oauth_token, {
                        maxAge: 86400,
                        secure: true
                    });
                    window.location.href = `https://api.twitter.com/oauth/authenticate?oauth_token=${response?.data?.oauth_token}`;
                }
            } catch (error) {
                console.error(error);
            }
        })();
    };
    useEffect( () => {
        async function fetchData() {
            try {
                const responseP = await axiosInterceptor().get(
                    "incas/giftcardPublicPolicy"
                );
                const data = responseP?.data;
                // value of reward showing on the front page = number of cards to be sent * value of each card (Opt card included)
                const tmpReward = data.valueRequired * data.numberOfCopiesRequired + data.valueOpt * data.numberOfCopiesOpt;
                setReward(isNaN(tmpReward) ? DEFAULT_REWARD_VAL:tmpReward )
                // console.log("fetchData,card num:"+JSON.stringify(responseP.data))
                if ( responseP.data.isEnoughCards) {//responseP.data.stat.count > 9
                    // setIsEnoughCard(false)
                    setButtonDisable(false)
                }else{
                    alert("No GC Left")
                }
            }catch (err){
                console.log(err)
            }
        }
        fetchData()
    },[])

    useEffect(() => {
        const { twclid, oauth_token, oauth_verifier, return_token } =
            queryString.parse(window.location.search);

        // Failed Authentication
        if (!(twclid || (oauth_token && oauth_verifier) || return_token)) {
            window.location.href = 'https://twitter.com/';
            removeAuthCookie('oauth_token');
            removeAuthCookie('access_token');
            removeAuthCookie('email_collected');
            localStorage.removeItem('twclid');
            localStorage.removeItem('return_token');
        }

        // Check whether twclid is already used for landing page
        if (twclid) {
            localStorage.setItem('twclid', twclid);
            axiosInterceptor().post('twitter/auth/checkAndCreateAllTwclid', {
                twclid: twclid
            });
        }

        if (return_token) {
            localStorage.setItem('return_token', return_token);
        }
    }, []);

    useEffect(() => {
        const { oauth_token, oauth_verifier } = queryString.parse(
            window.location.search
        );

        // Successful Twitter Login
        if (oauth_token && oauth_verifier) {
            history.push({
                pathname: '/callback',
                search: `?oauth_token=${oauth_token}&oauth_verifier=${oauth_verifier}`
            });
        }
    }, [authCookie?.oauth_token]);

    return (
        <Container fluid className="home_container">
            <Row>
                <Col sm={8}>
                    <h1>
                        <FormattedMessage
                            id="Home.welcome"
                            defaultMessage="Welcome to our Research Survey!"
                        />
                    </h1>
                    <h3>
                        <FormattedMessage
                            id="Home.hosted"
                            defaultMessage="Hosted on YourMorals.org"
                        />
                    </h3>
                    <p>
                        <FormattedMessage
                            id="Home.ourGoal"
                            defaultMessage="Our goal is to learn about people’s moral values. In exchange for {value}{currency}, we ask that you:"
                            values={{
                                currency:DEFAULT_CURRENCY,
                                value: reward,
                            }}
                        />
                    </p>
                    <ul>
                        <li>
                            <FormattedMessage
                                id="Home.read1"
                                defaultMessage="Read and agree to a Consent Form"
                            />
                        </li>
                        <li>
                            <FormattedMessage
                                id="Home.read2"
                                defaultMessage="Give access to your Twitter data (Tweets, follows, etc.) to be used for research purposes"
                            />
                        </li>
                        <li>
                            <FormattedMessage
                                id="Home.task"
                                defaultMessage="Complete 10-20 minutes of surveys"
                            />
                        </li>
                    </ul>
                    <p>
                        <FormattedMessage
                            id="Home.result"
                            defaultMessage="Once you complete these steps, you will be asked to provide an email address, to which we will send your compensation in the form of an Amazon gift card."
                        />
                    </p>
                    <p>
                        <FormattedMessage
                            id="Home.addition"
                            defaultMessage="In addition, if you choose, you can enter the main YourMorals.org website and view a report and visual feedback on how you scored on each survey. We'll show you how your responses compare to others, and we'll tell you what that might say about you."
                        />
                        VF2.0
                    </p>
                </Col>
                <Col sm={1}></Col>

                <Col sm={3} className="home_login">
                    <p>
                        <FormattedMessage
                            id="Home.signin"
                            defaultMessage="Please signin with Twitter below (Note: we do not store your password; it is for account verification purposes only):"
                        />
                    </p>
                    <div className="home_signin">
                        <a
                            className={
                                'twitter-signin' 
                                + (buttonDisable ? ' is-disabled' : '')
                            }
                            onClick={(e) => {
                                e.preventDefault();
                                login();
                            }}
                        >
                            <img className="twitter-image" src={twitter_logo} />
                            <FormattedMessage
                                id="Home.signinTwitter"
                                defaultMessage="Sign in with Twitter"
                            />
                        </a>
                    </div>
                </Col>
            </Row>
        </Container>
    );
}

export default HomePage;
